import React from 'react'
import "./AdventureSection.css"
import SnorkleImage from '../../assets/images/swimming-snorkle.png'
import zipLineImage from '../../assets/images/zip-line-image-min.png'
import garlicImage from '../../assets/images/garlic-image-min.png'


const AdventuresSection = () => {
  return (
    <>
<div className=" uk-section uk-height-viewport-2" uk-scrollspy="target: [uk-scrollspy-class]; cls: uk-animation-slide-bottom-small; delay: 600; offset-top: 100; repeat: true;">       
    <div className="uk-container ">   

    <div className='uk-margin-top' uk-scrollspy-class="uk-animation-slide-bottom-medium">
        <div>

        <div className='trip-ultra trip-heading-display uk-width-2-3@l'>
          We said yes to every new adventure—and learned there are a lot of us who aren't afraid of anything. 
      </div>

        </div>
    </div>





        <div id="page#20" className="tm-grid-expand uk-child-width-1-1 uk-grid-margin uk-grid uk-grid-stack" uk-grid="">
            <div className="uk-width-1-1 uk-first-column" id="page#19">
                    <div className="uk-position-z-index uk-flex uk-flex-middle uk-sticky uk-active uk-sticky-fixed" uk-sticky="offset: 40vh - 100%; end: !.tm-grid-expand;">    

                    <div className="uk-panel uk-width-1-1">            

                        <div className="uk-panel uk-position-absolute uk-width-1-1" uk-parallax="x: 0vw 0%,-100vw 25%; easing: 0; target: ![uk-grid].tm-grid-expand; start: 100vh + 10px;"  >

                        <div className='uk-flex uk-flex-middle uk-grid'>
                            <div className='uk-width-1-2@m uk-width-1-1@s '>
                                <div className="trip-heading-display trip-ultra"> 

                                <span className='trip-ultra trip-moss'> 
                                1,636 </span><br className="uk-hidden@s"/> shark-diving 
                                            experiences booked

                                </div>
                            <hr className='trip-border'/>

                            </div>

                            <div className='uk-width-1-2@m uk-width-1-1@s'>
                                                                
                                    <div className="uk-margin uk-text-center">
                                        <img src={SnorkleImage} alt="snorkle" className="trip-image" />   
                                    </div>
                            </div>
                        </div>

                            
                        </div>

                        <div className="uk-panel uk-position-absolute uk-width-1-1" uk-parallax="x: 100vw 0%,0vw 25%,-100vw 50%; easing: 0; target: ![uk-grid].tm-grid-expand; start: 100vh;" >

                        <div className='uk-flex uk-flex-middle uk-grid'>
                    <div className='uk-width-1-2@m uk-width-1-1@s '>
                        <div className="trip-heading-display trip-ultra"> 

                          <span className='trip-ultra trip-moss'> 
                          16,563 </span><br className="uk-hidden@s"/> ziplining <br className="uk-hidden@s"/> tours<br className="uk-hidden@s"/>  booked

                        </div>
                    <hr className='trip-border'/>

                    </div>

                    <div className='uk-width-1-2@m uk-width-1-1@s'>
                                                          
                              <div className="uk-margin uk-text-center">
                                <img src={zipLineImage} alt="snorkle" className="trip-image" />   
                            </div>
                    </div>
                </div>
                            



                        </div>
                        <div className="uk-panel uk-position-absolute uk-width-1-1" uk-parallax="x: 200vw 0%,0vw 50%,-100vw 75%; easing: 0; target: ![uk-grid].tm-grid-expand; start: 100vh;" >

                        <div className='uk-flex uk-flex-middle uk-grid'>
                    <div className='uk-width-1-2@m uk-width-1-1@s '>
                        <div className="trip-heading-display trip-ultra"> 

                          <span className='trip-ultra trip-moss'> 
                          47,015 </span><br className="uk-hidden@s"/> ghost & vampire <br className="uk-hidden@s"/> tours <br className="uk-hidden@s"/> booked

                        </div>
                    <hr className='trip-border'/>

                    </div>

                    <div className='uk-width-1-2@m uk-width-1-1@s'>
                                                          
                              <div className="uk-margin uk-text-center" uk-parallax="rotate: 0 0%, ; easing: 0;">
                                <img src={garlicImage} alt="snorkle" className="trip-image-small" />   
                            </div>
                    </div>
                </div>





                        </div>
                        <div className="uk-panel uk-position-absolute uk-width-1-1" uk-parallax="x: 300vw 0%,0vw 70%,-100vw 100%; easing: 0; target: ![uk-grid].tm-grid-expand; start: 100vh;" >






                        </div>

                    </div>

                    </div>
                    <div className="uk-sticky-placeholder" >

                    </div>
            </div>
        </div>
    </div>
</div>
    
    
    
    
    
    </>
  )
}

export default AdventuresSection